<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <responsable-editar-form @success="success"></responsable-editar-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <responsable-editar-form @success="success"></responsable-editar-form>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'responsable-editar-form': require('./ResponsableEditarForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
